import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SimpleDialogData } from '../../interfaces/simple-dialog-data.interface';

/**
 * Simple Dialog Component
 */
@Component({
  selector: 'app-simple-dialog',
  templateUrl: './simple-dialog.component.html',
  styleUrls: ['./simple-dialog.component.scss'],
})
export class SimpleDialogComponent implements OnInit {
  /**
   * Constructor
   *
   * @param data DialogData
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: SimpleDialogData) {
    this.data.leftButtonText = this.data.leftButtonText ?? 'Cancel';
    this.data.rightButtonText = this.data.rightButtonText ?? 'Accept';
  }

  ngOnInit(): void {}
}
